import { v4 as uuidv4 } from "uuid";
import { Component } from "../../../component";
import { NoteBlock } from "../block";

export interface ComponentBlock extends NoteBlock {
  "component-id": string;
  "package-id"?: string;
  type: "omega/query-omega/page/block/component/ComponentBlock";
}

export function isComponentBlock(block: NoteBlock): block is ComponentBlock {
  return (block as ComponentBlock)["component-id"] !== undefined;
}

export const newComponentBlock = (config: {
  comp: Component;
  blockIndex: number;
}) => {
  const { blockIndex, comp } = config;
  const block: ComponentBlock = {
    "component-id": comp["component-id"],
    type: "omega/query-omega/page/block/component/ComponentBlock",
    "block-index": blockIndex,
    "page-id": comp["page-id"],
    "app-id": comp["app-id"],
    "block-id": uuidv4(),
  };
  return block;
};
